module.exports = __webpack_public_path__ + "static/media/playIcon.911b92cc.svg";